import styled from 'styled-components';

export const StyledSettingsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
